import {
  GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID,
  GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID_SUCCESS,
  INSERT_MERCHANT_COMMISSIONS,
  INSERT_MERCHANT_COMMISSIONS_SUCCESS,
  UPDATE_MERCHANT_COMMISSIONS,
  UPDATE_MERCHANT_COMMISSIONS_SUCCESS,
  MERCHANT_COMMISSION_LIST_API_ERROR
  } from "./actionTypes"
  
  export const getPayFacCommissionsByPricingTableGuidAndMerchantGuid = record => ({
    type: GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID,
    payload: record,
  })

  export const getPayFacCommissionsByPricingTableGuidAndMerchantGuidSuccess = record => ({
    type: GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID_SUCCESS,
    payload: record,
  })

  export const insertMerchantCommissions = record => ({
    type: INSERT_MERCHANT_COMMISSIONS,
    payload: record,
  })

  export const insertMerchantCommissionsSuccess = record => ({
    type: INSERT_MERCHANT_COMMISSIONS_SUCCESS,
    payload: record,
  })
  
  export const updateMerchantCommissions = record => ({
    type: UPDATE_MERCHANT_COMMISSIONS,
    payload: record,
  })

  export const  updateMerchantCommissionsSuccess = record => ({
    type: UPDATE_MERCHANT_COMMISSIONS_SUCCESS,
    payload: record,
  })

  export const merchantCommissionListApiError = error => {
    return {
      type: MERCHANT_COMMISSION_LIST_API_ERROR,
      payload: error,
    }
  }

  